<template>
    <base-side-bar>
        <div class="flex flex-col items-center justify-center w-full mx-10">
            <wide-card
                title="Taille et évolution du marché"
                titleClass="text-center"
            >
                <img :src="url" class="my-6" />
                <!-- <pdf :src="src" v-for="i in numPages" :key="i" :page="i"></pdf> -->
                <div v-if="notFound">
                    <h2
                        class="text-xl font-extrabold leading-9 text-center text-blue-600 sm:text-xl sm:leading-10"
                    >
                        L'étude de marché de ce secteur sera <br />
                        <span class="text-blue-700"
                            >DISPONIBLE PROCHAINEMENT !</span
                        >
                    </h2>
                </div>
            </wide-card>
            <base-primary-button title="Suivant" @click="nextStep" />
        </div>
    </base-side-bar>
</template>

<script>
import WideCard from "../../../components/cards/wideCard";
import { mapGetters } from "vuex";
import { storage } from "@/services/firebase.service";

// import pdf from "vue-pdf";

// const loadingTask = pdf.createLoadingTask(`/Taille-et-evolution-du-marche.pdf`);

export default {
    components: {
        WideCard
        // pdf,
    },
    created() {
        this.$store.dispatch("forms/showSection", "Étude de marché");
        this.$store.dispatch(
            "forms/stepFocus",
            "Taille et évolution du marché"
        );
        let imagePath;
        if (this.isSimplifiedVersion) {
            imagePath = `gs://cri-bpi.appspot.com/market-research/simplified-version/${this.getSelectedActivities.temp_id}/1.jpg`;
        } else {
            imagePath = `gs://cri-bpi.appspot.com/market-research/detailed-version/${this.getSelectedActivities.temp_id}/1.jpg`;
        }

        const storageRef = storage.refFromURL(imagePath);
        storageRef
            .getDownloadURL()
            .then(url => {
                this.url = url;
            })
            .catch(error => {
                switch (error.code) {
                    case "storage/object-not-found":
                        this.notFound = true;
                        this.url = "/disponiblesoon.png";
                        break;
                }
            });
    },
    mounted() {
        // this.src.promise.then((pdf) => {
        //   this.numPages = pdf.numPages;
        // });
    },
    data() {
        return {
            //  page: 1,
            //  src: loadingTask,
            // numPages: undefined,
            url: "",
            notFound: false
        };
    },
    methods: {
        nextStep() {
            this.$store.dispatch(
                "forms/subStepComplete",
                "Taille et évolution du marché"
            );
            if (this.isSimplifiedVersion) {
                this.$router.push({
                    name: "analyse_concurrentielle",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.$router.push({
                    name: "sante_financiere_des_entreprises",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            }
        }
    },
    computed: {
        ...mapGetters("user", {
            isSimplifiedVersion: "isSimplifiedVersion"
        }),
        ...mapGetters("VotreProject", {
            getSelectedActivities: "getSelectedActivities"
        })
    }
};
</script>
<style>
.multiselect__tag {
    border-radius: 15px;
}
</style>
